let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7ed8t")).then(() => parcelRequire('5eYVV'));